import { CreatePlanningTemplatePage } from "@features/rh/horaires-de-travail/components/CreatePlanningTemplatePage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/horaires-de-travail/create")({
  loader: requirePermission(PERMISSIONS.RH.PLANNING.CREATE),
  staticData: {
    title: "Nouveau modèle d'horaire",
    showInBreadcrumb: true,
  },
  component: CreatePlanningTemplatePage,
});
